import type { SVGProps } from 'react'
import * as React from 'react'
const PersonalCabinetcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={33} height={32} fill='none' {...props}>
    <rect width={21.999} height={21.999} x={5.977} y={3.979} fill='url(#a)' rx={11} />
    <g filter='url(#b)'>
      <path
        fill='#B8DBB7'
        fillOpacity={0.5}
        d='M24.85 24.834v1.662c0 1.075-.787 1.857-1.662 1.857H10.765c-.962 0-1.662-.88-1.662-1.857v-1.662c0-2.934 2.1-5.28 4.724-5.28h.613a5.7 5.7 0 0 0 2.537.586c.875 0 1.75-.195 2.538-.586h.612c2.625 0 4.725 2.346 4.725 5.28'
      />
    </g>
    <path
      fill='#fff'
      d='M16.976 17.904c2.175 0 3.938-1.724 3.938-3.85s-1.763-3.85-3.938-3.85c-2.174 0-3.937 1.724-3.937 3.85s1.763 3.85 3.937 3.85'
    />
    <defs>
      <linearGradient id='a' x1={7.976} x2={24.403} y1={5.292} y2={28.483} gradientUnits='userSpaceOnUse'>
        <stop stopColor='#38DC71' />
        <stop offset={1} stopColor='#00812C' />
      </linearGradient>
      <filter
        id='b'
        width={23.75}
        height={16.8}
        x={5.102}
        y={15.554}
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feGaussianBlur in='BackgroundImageFix' stdDeviation={2} />
        <feComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_1249_56287' />
        <feBlend in='SourceGraphic' in2='effect1_backgroundBlur_1249_56287' result='shape' />
        <feColorMatrix in='SourceAlpha' result='hardAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' />
        <feOffset dx={0.2} dy={0.1} />
        <feGaussianBlur stdDeviation={0.5} />
        <feComposite in2='hardAlpha' k2={-1} k3={1} operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0' />
        <feBlend in2='shape' result='effect2_innerShadow_1249_56287' />
      </filter>
    </defs>
  </svg>
)
export default PersonalCabinetcon
